import { createRoot } from 'react-dom/client'
import { Chart, registerables } from 'chart.js'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
// Apps
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import "./main.css";
import { AppRoutes } from './app/routing/AppRoutes'
import { AuthProvider } from './app/modules/auth'
import { FiltrosProvider } from './providers/FiltrosProvider'
import { Providers } from "@microsoft/mgt-element";
import { Msal2Provider } from "@microsoft/mgt-msal2-provider";
import { LocalizationHelper } from "@microsoft/mgt-react";
import { graphMsal2Config } from "./authConfig";

Providers.globalProvider = new Msal2Provider(graphMsal2Config);

Chart.register(...registerables)
LocalizationHelper.strings = {
  _components: {
    login: {
      signInLinkSubtitle: "Entrar com Microsoft",
      signOutLinkSubtitle: "Sair",
      signInWithADifferentAccount: "Entrar com uma conta diferente",
    },
  },
};

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <AuthProvider>
          <FiltrosProvider>
            <AppRoutes />
          </FiltrosProvider>
        </AuthProvider>
      </MetronicI18nProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}
